<template>
    <div class="pagination-container" layout="row top-left">
      <div v-for="page in pages" :class="{page: true, current: page==current}" @click="select(page)">
        {{page}}
      </div>
    </div>
</template>

<script>
  export default {

    name: "pagination",
    props: ['from', 'to', 'current'],
    data() {
      return {

      }
    },
    created() {

    },
    computed: {
      pages: function() {
        const from = this.$props.from;
        const to = this.$props.to;
        const pages = [];
        for (let n = from; n <= to; n++) {
          pages.push(n);
        }
        return pages;
      }
    },
    methods: {
      select(page) {
        console.log('select', page);
        this.$emit('onSelect', page);
      }
    }
  }
</script>

<style scoped>
  .pagination-container {
    margin-top: 0.5rem;
    font-size: 0.8rem;
    font-weight: 100;
  }



  .current {
    font-weight: 400;
  }

  .page {
    margin-right: 0.3rem;
    cursor: pointer;

  }


</style>



// WEBPACK FOOTER //
// src/components/Pagination.vue